import { Box, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { useTheme } from "../../../../../context/themeContext";
import Card from "./card";
import styles from "./style.module.css";

const Applications = () => {
	const { theme } = useTheme();
	const { applications } = useSelector((state) => state.manageProjects);

	const renderProjects =
		Array.isArray(applications) && applications.length > 0
			? applications.map((project, index) => {
					return <Card key={index} project={project} />;
			  })
			: null;

	return (
		<Box className={styles.hosted}>
			<Typography
				variant="body1"
				sx={{
					color: theme.palette.darkgrey.darkgrey600,
					fontSize: "24px",
					fontWeight: "500",
				}}
			>
				{Array.isArray(applications) && applications.length > 0
					? applications.length
					: 0}{" "}
				Project Applications
			</Typography>
			<Box className={styles.content}>{renderProjects}</Box>
		</Box>
	);
};

export default Applications;
